export default "/images/vendor/flag-icon-css/flags/4x3/ug.svg?ac0f0d78f5f94572d57b389da33166db";